

    <div class="container">
        <mat-card class="example-card">
            <mat-card-header>
                <div class="col-md-12 title-solicitud" align="center">
                    <strong>Seguimiento de certificados</strong>
                </div>
            </mat-card-header>
            <mat-card-content>
                <div class="mat-elevation-z8">
                    <div class="div-search">
                        <mat-form-field class="search-sol">
                            <input matInput placeholder="Número Solicitud..." id="Sol" name="Sol"
                                [formControl]="idSolicitud" required>
                            <mat-icon matSuffix>edit</mat-icon>
                            <mat-hint>Ingrese el número del documento</mat-hint>
                            <mat-error *ngIf="idSolicitud.invalid">Solo números</mat-error>
                        </mat-form-field>
                        <button class="btn-search" mat-raised-button (click)="getSolicitud()" color="primary"
                            [disabled]="!idSolicitud.valid">Buscar</button>
                    </div>
                    <!--  -->
                    <div class="info-container" align="center">
                        <div class="title-info">
                            <p>Datos de la Solicitud</p>
                        </div>
                        <div class="tallerontenedor">
                            <div class="tallerInfo">
                                <span>ID de la solicitud</span>
                                <strong>{{ idEncontrado ? sol_encontrada.id : '' }}</strong>
                            </div>
                            <div class="tallerInfo">
                                <span>Rut Solicitante</span>
                                <strong>{{ idEncontrado ? sol_encontrada.rut : '' }}</strong>
                            </div>
                            <div class="tallerInfo">
                                <span>Tipo de certificado</span>
                                <strong>{{ idEncontrado ? sol_encontrada.tipo : ''}}</strong>
                            </div>
                            <div class="tallerInfo" >
                                <span>Estado</span>
                                <strong><b>{{ idEncontrado ? (sol_encontrada.estado | uppercase) : '' }}</b></strong>
                            </div>          
                            <div class="tallerInfo">
                                <span>Ingreso CAS</span>
                                <strong>{{ idEncontrado ? sol_encontrada.ingresoCAS : '' }}</strong>
                            </div>
                            <div class="tallerInfo">
                                <span>Fecha de ingreso</span>
                                <strong>{{ idEncontrado? (sol_encontrada.fecha_ingreso | date: 'dd/MM/yyyy')  : '' }}</strong>
                            </div>
                            <div class="tallerInfo">
                                <span>Dirección</span>
                                <strong>{{ idEncontrado ? sol_encontrada.dir : '' }}</strong>
                            </div>
                            <div class="tallerInfo">
                                <span>Rol</span>
                                <strong>{{ idEncontrado ? sol_encontrada.rol : '' }}</strong>
                            </div>
                        </div>
                    </div>
                </div>
            </mat-card-content>
            <mat-card-actions>
            </mat-card-actions>
        </mat-card>
    </div>

<!-- 
    </mat-sidenav-content>
</mat-sidenav-container> -->


<!-- <ng-template #openModalCert>
    <mat-dialog-content>
        <div class="col-md-12">
            <div class="col-md-3 col-sm-3 hidden-sm hidden-xs " style="width: 18%">
                <img class="logo_muni_modal" src="assets/images/logo_concon.png">
            </div>
            <div class="form-group col-md-9 col-sm-9 col-xs-12">
                <div class="col-md-12" align="center">
                    <h1><strong>SOLICITUD DE CERTIFICADO</strong></h1>
                </div>
                <div class="col-md-12" align="center">
                    <h3>SOLICITUD N°: <strong>{{seguim_cert.num_solicitud}}</strong></h3>
                    
                </div>
            </div>
            <div class="form-group col-md-12 d-flex justify-content-center">
                <hr />
                <div class="center col-md-12" align="center">
                    <div class="table-responsive container-info hidden-xs hidden-sm" align="center">

                        <div class="tallerontenedor hidden-xs">
                            <div class="tallerInfo">
                                <span>Rol:</span>
                                <strong>{{seguim_cert.rol}}</strong>
                            </div>
                        </div>
                        <div class="tallerontenedor hidden-xs">
                            <div class="tallerInfo">
                                <span>Tipo:</span>
                                <strong>{{seguim_cert.tipo}}</strong>
                            </div>
                        </div>
                        <div class="tallerontenedor hidden-xs">
                            <div class="tallerInfo">
                                <span>Dirección:</span>
                                <strong>{{seguim_cert.direccion}}</strong>
                            </div>
                        </div>
                        <div class="tallerontenedor hidden-xs">
                            <div class="tallerInfo">
                                <span>Fecha de ingreso:</span>
                                <strong>{{seguim_cert.fecha_ingreso | date:'dd/MM/yyyy'}}</strong>
                            </div>
                        </div>
                        <div class="tallerontenedor hidden-xs">
                            <div class="tallerInfo">
                                <span>Estado:</span>
                                <strong>{{seguim_cert.estado_web | uppercase}}</strong>
                            </div>
                        </div>
                    </div>
                </div>

                <div class=" hidden-lg hidden-md" align="center">

                    <div class="tallerInfo2">
                        <div>
                            <span>Rol:</span>
                        </div>
                        <div>
                            <strong class="info">{{seguim_cert.rol}}</strong>
                        </div>
                    </div>
                    <div class="tallerInfo2">
                        <div>
                            <span>Tipo:</span>
                        </div>
                        <div>
                            <strong class="info">{{seguim_cert.tipo}}</strong>
                        </div>
                    </div>
                    <div class="tallerInfo2">
                        <div>
                            <span>Dirección:</span>
                        </div>
                        <div>
                            <strong class="info">{{seguim_cert.fecha_ingreso | date:'dd/MM/yyyy'}}</strong>
                        </div>
                    </div>
                    <div class="tallerInfo2">
                        <div>
                            <span>Estado:</span>
                        </div>
                        <div>
                            <strong class="info">{{seguim_cert.estado_web | uppercase}}</strong>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
        <button matDialogClose mat-raised-button color="warn" id="clean_ingreso_antecedentes_edif" data-dismiss="modal"
            (click)="cleanData()">Cerrar</button>

    </mat-dialog-actions>
</ng-template> -->
<!-- <ng-template #openModal>
    <h2 mat-dialog-title>Informacion Expediente</h2>
    <mat-dialog-content>
        <div class="form-horizontal">
            <div class="form-group">
                <label class="col-md-4 control-label" for="rol">No se encontro la informacion solicitada</label>
            </div>
        </div>

    </mat-dialog-content>
    <mat-dialog-actions align="end">
        <button matDialogClose mat-raised-button color="warn" id="clean_ingreso_propiet" data-dismiss="modal"
            (click)="cleanData()">Cancelar</button>
    </mat-dialog-actions>
</ng-template> -->